import { Notification, NotificationTypes } from 'components/common/Notification/Notification';
import { bodyMessageOf, messageOf } from 'utils/apiError';

/**
 * Tells the user a request failed: in the backend's words when it sent any, in the error's own
 * otherwise — the message a failed grade save shows (#136).
 *
 * For a method whose callers fire it and forget it, which is most of the list fetches: once it
 * reports its own failure, a caller that does not await it is no longer dropping an error.
 */
export const reportFailure = (error: unknown): void => {
  Notification.create({
    type: NotificationTypes.ERROR,
    title: bodyMessageOf(error) ?? messageOf(error),
  });
};
